interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return <main className="min-w-0 grow p-xl bg-level-01/full">{children}</main>;
}

Layout.displayName = 'Layout';
